import { MediaGrid } from "../components/MediaLibrary.tsx";
import { Card } from "../components/ui.tsx";

export function MediaPage() {
  return (
    <div className="page">
      <div className="page-header">
        <h1>Media</h1>
        <p>Logos, icons and graphics for email, hosted where any inbox can load them.</p>
      </div>
      <Card>
        <div className="card-body">
          <MediaGrid />
        </div>
      </Card>
    </div>
  );
}
